// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { reorderPadItemStyles } from "@steiner/App/Widgets/ReorderPad/ReorderPadItem";
import { ellipsis, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

reorderPadItemStyles.dataTableDescriptionCell = {
    mergeCss: true,
    css: css`
        width: 882px;
        word-wrap: break-word;
        white-space: normal;
        ${xScreen("gte", "xl")} {
            width: 1037px;
        }
        ${xScreen("gt", "lg")} {
            ${TypographyStyle} {
                ${ellipsis(1)}
            }
        }
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};

reorderPadItemStyles.productPriceStyles = {
    quoteMessage: {
        text: {
            color: "text.main",
            size: 14,
            weight: "normal",
        },
    },
    price: {
        realTimeText: {
            size: 14,
            color: "text.main",
            weight: "normal",
        },
        priceText: {
            color: "text.main",
            size: 14,
            weight: "normal",
        },
        errorText: {
            color: "danger",
            size: 14,
            weight: "normal",
        },
        unitOfMeasure: {
            unitOfMeasureText: {
                color: "text.main",
                size: 14,
                weight: "normal",
            },
        },
    },
};

reorderPadItemStyles.addToCartCell = {
    css: css`
        ${xScreen("lte", "md")} {
            & > ${TypographyStyle} {
                display: flex;
                align-items: center;
            }
        }
    `,
};

reorderPadItemStyles.actionsContainer = {
    css: css`
        display: grid;
        grid-template-columns: 104px auto;
        gap: 12px 10px;
        .qtyFieldWrapper {
            justify-content: center;
        }
    `,
};

reorderPadItemStyles.productAddToListLinkStyles = {
    link: {
        css: css`
            grid-area: 2 / 1 /3 /3;
        `,
    },
};

reorderPadItemStyles.productAddToCartButtonStyles = {
    css: css`
        max-width: 46px;
    `,
    sizeVariant: "small",
};
